import React from "react";
import CalendarScreen from "../../screens/CalendarScreen/calendar-screen";

const CalendarContainer = () => {
  return <CalendarScreen />
  
};

export default CalendarContainer;